import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'

import pwaRoutines from './service/PWA/pwaRoutines'
import * as OfflinePluginRuntime from '@lcdp/offline-plugin/runtime'

OfflinePluginRuntime.install(pwaRoutines)

const root = document.getElementById('root_container') as HTMLElement

ReactDOM.createRoot(root).render(<App />)
